"use client";

import IconEye from "@/components/Icons/IconEye";
import useViewerCount from "../_hooks/useViewersCount";



type ViewerCountDisplayProps = {
  carId: string;
  showLabel?: boolean;
  className?: string;
};

export default function NumberofViewers({ carId, className = "" }: ViewerCountDisplayProps) {
  const { data: viewerCount = 10, isLoading, isError } = useViewerCount(carId);

  if (isLoading) {
    return <span className={className}>-</span>;
  }

  if (isError) {
    return <span className={className}>-</span>;
  }

  return (
    <div className={`my-3 flex items-center space-x-2 font-inter text-base font-medium xl:hidden ${className}`}>
      {" "}
      <IconEye />
      <div className="font-bold">{ viewerCount } People { " "}</div>
    </div>
  );
}
